import { Button, Input, Modal } from "antd";
import React, { useState } from "react";

const TokenSelectModal = ({ open, onClose, onTokenSelect }) => {
  const presetTokens = [100, 150, 200];
  const [selectedToken, setSelectedToken] = useState(null);
  const [customToken, setCustomToken] = useState("");
  const [error, setError] = useState("");

  const handleSelect = (value) => {
    setError("");

    if (selectedToken === value) {
      setSelectedToken(null);
    } else {
      setSelectedToken(value);
    }

    setCustomToken("");
  };

  const handleCustomChange = (e) => {
    const val = e.target.value;
    setSelectedToken(null);
    setCustomToken(val);

    if (val !== "" && Number(val) <= 0) {
      setError("Token value must be greater than 0");
    } else {
      setError("");
    }
  };

  const handleConfirm = () => {
    const finalToken = selectedToken || Number(customToken);

    if (!finalToken || finalToken <= 0) {
      setError("Please select or enter a valid token amount");
      return;
    }

    onTokenSelect(finalToken);
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={600}
      className="universal-modal"
    >
      <div className="universal-modal-content">
        <h4
          className="universal-modal-title"
          style={{ textAlign: "center", color: "white" }}
        >
          Choose Token
        </h4>

        <div
          className="token-options"
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          {presetTokens.map((token) => (
            <Button
              key={token}
              className={`border-button token-btn ${
                selectedToken === token ? "token-btn-active" : ""
              }`}
              onClick={() => handleSelect(token)}
            >
              {token} Token
            </Button>
          ))}
        </div>

        <div style={{ textAlign: "center", marginTop: 20 }}>
          <Input
            type="number"
            placeholder="Custom Token"
            value={customToken}
            onChange={handleCustomChange}
            className="custom-token-input"
          />
        </div>

        {error && (
          <p style={{ color: "red", textAlign: "center", marginTop: "10px" }}>
            {error}
          </p>
        )}

        <div style={{ textAlign: "center", marginTop: "26px" }}>
          <Button
            style={{ maxWidth: "300px", height: "40px" }}
            className="Fill-button"
            onClick={handleConfirm}
          >
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default TokenSelectModal;
